export default __webpack_public_path__ + "static/media/Layer 7.0bef7d8f.png";